/***************************************
PRODUCT PAGE – DYNAMIC MESSAGE INPUTS
***************************************/
document.addEventListener('DOMContentLoaded', () => {
  const quantityInput = document.querySelector('input[name="quantity"]');
  const originalInput = document.getElementById("personal-message");

  if (!quantityInput || !originalInput) return;

  function updateInputs(quantity) {
    const existingClones = document.querySelectorAll(".cloned-personal-message");
    const existingCount = existingClones.length + 1; // +1 for original field

    // Add new fields if quantity increased
    for (let i = existingCount + 1; i <= quantity; i++) {
      const clone = originalInput.cloneNode(true);
      clone.id = `personal-message-${i}`;
      clone.name = `properties[Personalized Message ${i}]`;
      clone.placeholder = `Enter your message ${i}`;
      clone.value = ''; // empty for new field
      clone.classList.add("cloned-personal-message");

      // Insert after the last existing input to fix reverse numbering
      const lastInput = document.querySelector('input[id^="personal-message"]:last-of-type');
      lastInput.after(clone);
    }

    // Remove extra fields if quantity decreased
    for (let i = quantity + 1; i < existingCount + 1; i++) {
      const el = document.getElementById(`personal-message-${i}`);
      if (el) el.remove();
    }
  }

  updateInputs(parseInt(quantityInput.value));

  quantityInput.addEventListener("change", function () {
    updateInputs(parseInt(this.value));
  });
});


/***************************************
PRODUCT PAGE – MESSAGE VALIDATION
***************************************/
document.addEventListener('DOMContentLoaded', () => {
  const charCountMap = {}; // store char count elements for each input
  const acknowledgeCheckbox = document.getElementById('acknowledge');
  const errorMsg = document.getElementById('message-error');
  const form = document.querySelector('product-form form');

  if (!form) return;

  let isSubmitting = false; // 🔥 DOUBLE SUBMIT GUARD

  function getSelectedSizeValue() {
    const fs = document.querySelectorAll('fieldset.product-form__input');
    for (const fieldset of fs) {
      const legend = fieldset.querySelector('legend');
      if (legend && legend.textContent.toLowerCase().includes('size')) {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      }
    }
    return '';
  }

 function getMaxLength(size) {
  const productInfo = document.getElementById("product-info");
  const collectionHandle = productInfo ? productInfo.dataset.collectionHandle : '';
  console.log("Collection handle:", collectionHandle); // for debugging


  size = size.trim();

  if (collectionHandle === "roll-cakes") {
    if (size.includes('9"')) return 20;
    if (size.includes('6"')) return 12;
    return 9999; // default for roll-cakes
  }

  if (size.includes('9"')) return 17;
  if (size.includes('6"')) return 7;
  return 0;
}



  function removeEmojis(text) {
    return text.replace(/[\p{Extended_Pictographic}]/gu, '');
  }

  function liveValidate(input) {
    const size = getSelectedSizeValue();
    const max = getMaxLength(size);

    if (max === 0) {
      input.value = '';
      input.disabled = true;
      updateAddToCartState();
      return;
    }

    input.disabled = false;
    input.maxLength = max;

    let value = removeEmojis(input.value);
    if (value.length > max) value = value.slice(0, max);
    input.value = value;

    // Update char count display: SHOW ONLY FOR CURRENT INPUT
    Object.keys(charCountMap).forEach(id => {
      if (id === input.id) {
        charCountMap[id].textContent = `${value.length}/${max} characters`;
        charCountMap[id].style.display = 'block';
      } else {
        charCountMap[id].style.display = 'none';
      }
    });

    updateAddToCartState();
  }

  function updateAddToCartState() {
    const addToCartBtn = form.querySelector('button[type="submit"]');
    if (!addToCartBtn) return;

    const allMessages = Array.from(document.querySelectorAll('input[id^="personal-message"]'))
      .map(i => i.value.trim())
      .filter(Boolean);

    if (allMessages.length > 0 && acknowledgeCheckbox && !acknowledgeCheckbox.checked) {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('disabled');
      if (errorMsg) {
        errorMsg.textContent = 'Please confirm that your personalized message is final.';
        errorMsg.style.display = 'block';
      }
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('disabled');
      if (errorMsg) errorMsg.style.display = 'none';
    }
  }

  // Initialize char count elements and input listeners
  function initMessageInputs() {
    document.querySelectorAll('input[id^="personal-message"]').forEach(input => {
      // Avoid duplicating listeners
      if (!charCountMap[input.id]) {
        // Create char count element if missing
        let countEl = document.createElement('div');
        countEl.className = 'char-count';
        countEl.style.display = 'none'; // initially hidden
        input.insertAdjacentElement('afterend', countEl);
        charCountMap[input.id] = countEl;

        input.addEventListener('input', () => liveValidate(input));
      }
    });
  }

  initMessageInputs();
  document.addEventListener('change', (e) => {
    if (e.target.closest('fieldset.product-form__input')) {
      document.querySelectorAll('input[id^="personal-message"]').forEach(input => liveValidate(input));
    }
  });

  if (acknowledgeCheckbox) acknowledgeCheckbox.addEventListener('change', updateAddToCartState);

  liveValidate(document.getElementById('personal-message')); // initial validation

  /***************************************
  🔥 DAWN ADD TO CART OVERRIDE
  ***************************************/
  form.addEventListener(
    'submit',
    async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (isSubmitting) return;
      isSubmitting = true;

      const formData = new FormData(form);
      const variantId = formData.get('id');
      const qty = parseInt(formData.get('quantity') || 1, 10);
      const bundleId = Date.now();

      // Collect all personalized messages
      const messages = {};
      const messageValues = [];

      document.querySelectorAll('input[id^="personal-message"]').forEach(input => {
        const val = input.value.trim();
        if (val) {
          const key = input.name.replace('properties[', '').replace(']', '');
          messages[key] = val;
          messageValues.push(val);
        }
      });

      // Add main product
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: qty,
          properties: { ...messages, _bundle_id: bundleId, _type: 'main' }
        })
      });

      // Add personalization fee if needed
      if (messageValues.length) {
        const feeHandle = 'personalization-fee';
        const feeRes = await fetch(`/products/${feeHandle}.js`);
        const feeProduct = await feeRes.json();

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: feeProduct.variants[0].id,
            quantity: messageValues.length,
            properties: {
              'For cake message': messageValues.join(' | '),
              _bundle_id: bundleId,
              _type: 'fee'
            }
          })
        });
      }

      window.location.href = '/cart';
    },
    true
  );

  // Re-initialize inputs when quantity changes (to add new cloned inputs)
  document.querySelector('input[name="quantity"]')?.addEventListener('change', () => {
    setTimeout(() => {
      initMessageInputs();
      document.querySelectorAll('input[id^="personal-message"]').forEach(input => liveValidate(input));
    }, 50);
  });
});

 
document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.includes('/cart')) return;

  let isSyncing = false;

  async function syncPersonalizationFees() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const updates = {};
      const reAddQueue = [];
      const removeKeys = [];
 
      cart.items.forEach(mainItem => {
        if (!mainItem.properties) return;

        const messages = Object.keys(mainItem.properties)
          .filter(k => k.startsWith('Personalized Message'))
          .map(k => mainItem.properties[k])
          .filter(Boolean);

        if (!messages.length) return;

        const msgStr = messages.join(' | ');

        const feeItem = cart.items.find(item =>
          item.product_title === 'Personalization Fee' &&
          item.properties?.['For cake message'] === msgStr
        );

        if (feeItem && feeItem.quantity !== messages.length) {
          updates[feeItem.key] = messages.length;
        }
      });

      /***************************************
      2️⃣ REMOVE ORPHAN FEES
      ***************************************/
      cart.items.forEach(item => {
        if (item.product_title !== 'Personalization Fee') return;

        const feeMsg = item.properties?.['For cake message'];
        if (!feeMsg) return;

        const hasMain = cart.items.some(mainItem => {
          if (!mainItem.properties) return false;

          const msgs = Object.keys(mainItem.properties)
            .filter(k => k.startsWith('Personalized Message'))
            .map(k => mainItem.properties[k])
            .filter(Boolean);

          return msgs.join(' | ') === feeMsg;
        });

        if (!hasMain) {
          removeKeys.push(item.key);
        }
      });

      /***************************************
      3️⃣ 🔥 NEW FEATURE
      FEE REMOVED → REMOVE MESSAGE FROM MAIN
      ***************************************/
      cart.items.forEach(mainItem => {
        if (!mainItem.properties) return;

        const messageKeys = Object.keys(mainItem.properties)
          .filter(k => k.startsWith('Personalized Message'));

        if (!messageKeys.length) return;

        const messages = messageKeys
          .map(k => mainItem.properties[k])
          .filter(Boolean);

        if (!messages.length) return;

        const msgStr = messages.join(' | ');

        const hasFee = cart.items.some(item =>
          item.product_title === 'Personalization Fee' &&
          item.properties?.['For cake message'] === msgStr
        );

        // 🚨 Fee missing but message exists
        if (!hasFee) {
          const cleanProps = {};

          Object.keys(mainItem.properties).forEach(key => {
            if (!key.startsWith('Personalized Message')) {
              cleanProps[key] = mainItem.properties[key];
            }
          });

          updates[mainItem.key] = 0;

          reAddQueue.push({
            id: mainItem.variant_id,
            quantity: mainItem.quantity,
            properties: cleanProps
          });
        }
      });

   
      if (Object.keys(updates).length) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }

      for (const item of reAddQueue) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(item)
        });
      }

      if (removeKeys.length) {
        const removeObj = {};
        removeKeys.forEach(k => (removeObj[k] = 0));

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: removeObj })
        });
      }

      if (
        Object.keys(updates).length ||
        removeKeys.length ||
        reAddQueue.length
      ) {
        setTimeout(() => window.location.reload(), 300);
      }

    } catch (err) {
      console.error('Cart sync error:', err);
    }

    isSyncing = false;
  }


  const cartContainer = document.querySelector('cart-items');
  if (cartContainer) {
    const observer = new MutationObserver(() =>
      setTimeout(syncPersonalizationFees, 300)
    );
    observer.observe(cartContainer, { childList: true, subtree: true });
  }

  document.addEventListener('click', e => {
    const target = e.target.closest('a[href*="/cart/change"]');
    if (target) {
      setTimeout(syncPersonalizationFees, 500);
    }
  });
});



